import React from "react";
import SummaryWrapper from "../SummaryWrapper";
import {
  presentIllnessOptions,
  pastMedicalOptions,
  chiefComplaintsOptions,
  medicalTreatmentOptions,
  surgicalTreatmentOptions,
  maritalStatusOptions,
  educationalOptions,
  smokingOptions,
  alcoholOptions,
  informantOptions,
  functionalOptions,
  knownAllergiesOptions,
  relationOptions,
} from "../../Options/historyOptions";
import {
  getPastMedicalHistorySummary,
  getLabelTagsWithDescription,
  getLabelTag,
  getLabelTagsArray,
  getLabelTagInput,
  getLabelTagYesNO,
  getLabelTagsWithDynamicInputs,
} from "../constructTextFromValues";
import { HistoryOutlined } from "@ant-design/icons";
import "../../summary.css";

const DoctorHistorySummary = ({ formData }) => {
  const historySummaryItems = [];

  const pushHistoryItem = (key, label, children) => {
    historySummaryItems.push({ key, label, children });
  };

  const constructHistorySummaryItems = () => {
    const history = formData?.history || {};

    if (
      history.informant ||
      history.relation_with_patient ||
      history.informant_name
    ) {
      pushHistoryItem(
        "1",
        "Informant",
        <>
          {getLabelTag(informantOptions, history.informant)}
          {getLabelTag(relationOptions, history.relation_with_patient)}
          {getLabelTagInput(
            "Others details",
            history?.relation_with_patient_others
          )}
          {getLabelTagInput("Name", history.informant_name)}
        </>
      );
    }

    if (history.chief_complaints || history.others_chief_complaint) {
      pushHistoryItem(
        "2",
        "Chief Complaints",
        <>
          {getLabelTagsArray(
            chiefComplaintsOptions,
            history.chief_complaints,
          )}
          {getLabelTagsWithDynamicInputs(history?.chief_complaints_others)}
        </>
      );
    }

    if (
      getLabelTagsWithDescription(presentIllnessOptions, history)?.length > 0
    ) {
      pushHistoryItem(
        "3",
        "Present Illness",
        <>
          {getLabelTagsWithDescription(presentIllnessOptions, history)}
          {getLabelTagsWithDynamicInputs(history?.present_illness_others)}{" "}
        </>
      );
    }

    if (
      getLabelTagsWithDescription(
        medicalTreatmentOptions,
        history?.treatment_history
      )?.length > 0
    ) {
      pushHistoryItem(
        "4",
        "Medical Treatment History",
        <>
          {getLabelTagsWithDescription(
            medicalTreatmentOptions,
            history?.treatment_history
          )}
          {getLabelTagsWithDynamicInputs(
            history?.treatment_history?.medical_treatment_others
          )}
        </>
      );
    }

    if (
      getLabelTagsWithDescription(
        surgicalTreatmentOptions,
        history?.treatment_history
      )?.length > 0
    ) {
      pushHistoryItem(
        "5",
        "Surgical Treatment History",
        <>
          {getLabelTagsWithDescription(
            surgicalTreatmentOptions,
            history?.treatment_history
          )}
          {getLabelTagsWithDynamicInputs(
            history?.treatment_history?.surgical_treatment_others
          )}
        </>
      );
    }

    if (getPastMedicalHistorySummary(pastMedicalOptions, history)?.length > 0) {
      pushHistoryItem(
        "6",
        "Past Medical History",
        getPastMedicalHistorySummary(pastMedicalOptions, history)
      );
    }

    if (history.surgical_history || history.surgical_history_details) {
      pushHistoryItem(
        "7",
        "Past Surgical History",
        <>
          {getLabelTagYesNO(history.surgical_history)}
          {getLabelTagInput("Details", history.surgical_history_details)}
        </>
      );
    }

    if (
      history.marital_status ||
      history.education ||
      history.smoking ||
      history.alcohol
    ) {
      pushHistoryItem(
        "8",
        "Personal History",
        <>
          {getLabelTag(maritalStatusOptions, history.marital_status)}
          {getLabelTag(educationalOptions, history.education)}
          {getLabelTag(smokingOptions, history.smoking)}
          {getLabelTagInput("Smoking since", history?.smoking_since, "yrs")}
          {getLabelTagInput(
            "Stopped smoking since",
            history?.stopped_smoking_since,
            "yrs"
          )}
          {getLabelTag(alcoholOptions, history.alcohol)}
        </>
      );
    }

    if (
      getLabelTagsWithDescription(knownAllergiesOptions, history)?.length > 0
    ) {
      pushHistoryItem(
        "9",
        "Known Allergies",
        <>
          {getLabelTagsWithDescription(knownAllergiesOptions, history)}
          {getLabelTagsWithDynamicInputs(history?.known_allergies_others)}
        </>
      );
    }

    if (history.functional_capacity) {
      pushHistoryItem(
        "10",
        "Previous Functional Capacity",
        getLabelTag(functionalOptions, history.functional_capacity)
      );
    }

    return historySummaryItems;
  };

  return (
    <SummaryWrapper
      items={constructHistorySummaryItems()}
      title={
        <span style={{ fontWeight: "normal" }}>
          <HistoryOutlined style={{ color: "var(--ant-primary-color)", fontWeight: "bold" }} />{" "}
          History
        </span>
      }
    />
  );
};

export default DoctorHistorySummary;
